var React = require('react');

function List (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_229","data-name":"Path 229","d":"M5580,3571.683h-18.927v-1.235H5580Zm-21.555-11.408H5556v2.524h2.445Zm21.555.71h-18.927v1.236H5580Zm-21.555,8.753H5556v2.524h2.445Zm0,9.464H5556v2.523h2.445Zm21.555.709h-18.927v1.235H5580Z","transform":"translate(-5556 -3560.275)","fill":"#fff"}));
}

List.defaultProps = {"width":"24","height":"21.45","viewBox":"0 0 24 21.45"};

module.exports = List;

List.default = List;
